import React, { createContext, useContext, useState } from 'react';

interface RequestRideContextType {
  isOpen: boolean;
  initialServiceType: string;
  entryPoint: 'traslados' | 'excursiones' | null;
  open: (serviceType?: string, entryPoint?: 'traslados' | 'excursiones') => void;
  close: () => void;
}

const RequestRideContext = createContext<RequestRideContextType | undefined>(undefined);

export const useRequestRideContext = () => {
  const context = useContext(RequestRideContext);
  if (!context) {
    throw new Error('useRequestRideContext must be used within RequestRideProvider');
  }
  return context;
};

export const RequestRideProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialServiceType, setInitialServiceType] = useState('persona');
  const [entryPoint, setEntryPoint] = useState<'traslados' | 'excursiones' | null>(null);

  const open = (serviceType?: string, entryPointVal?: 'traslados' | 'excursiones') => {
    if (serviceType) setInitialServiceType(serviceType);
    if (entryPointVal) setEntryPoint(entryPointVal);
    setIsOpen(true);
  };
  const close = () => setIsOpen(false);

  return (
    <RequestRideContext.Provider value={{ isOpen, initialServiceType, entryPoint, open, close }}>
      {children}
    </RequestRideContext.Provider>
  );
};
